import React from "react";

function KpkEntryToPrisoner() {
  return (
    <div className="bg-kpk-entry-to-prisoner py-5">
      <div className="container">
        <div>
          <h2 className="text-h-black text-light">Upon Entering the Prison</h2>
        </div>

        <div className="row row-cols-1 row-cols-md-3 g-4 my-5">
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “[Mopping] became a game to not let new prisoners go to the
                  barracks until they extorted money from them – anywhere from
                  50,000 to 100,000 rupees. They were beaten to a pulp, like
                  you’ve seen in a boxing ring, blood dripping from their eyes
                  and faces.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Akram Mehsud</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “In Peshawar jail, you’re stuck, shoulder to shoulder, in a
                  shared barrack with 180-190 prisoners, with two to three
                  people on one bed. When a new prisoner arrives, he must sleep
                  in the middle of these two. There’s nothing on the bed,
                  nothing under you – no – and they are full of bedbugs.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Wasim Mehsud</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “New prisoners are made to [clean], to initiate them into the
                  [give and take – the transactional nature of prison
                  extortion], or this work is given to the heroin addicts. The
                  actual cleaners will use the addicts for cleaning tasks, who
                  will agree to complete these in exchange for drugs.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Wasim Mehsud</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KpkEntryToPrisoner;
